/* Label each print-on-demand application with a heading and the date, so it is easy to spot in the inbox. */
(function () {
  var form = document.getElementById('sa-pod-form');
  if (!form) return;
  form.addEventListener('submit', function () {
    var body = form.querySelector('[name="contact[body]"]');
    if (!body || body.getAttribute('data-stamped')) return;
    var d = new Date();
    var date = d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    body.value = 'POD ACCOUNT APPLICATION SUBMISSION - ' + date + '\n\n' + body.value;
    body.setAttribute('data-stamped', '1');
  });
})();
